import styled from "styled-components";

export const StyledContainer = styled.div<{ align: "left" | "right"; position: "absolute" | "fixed" }>`
    position: ${({ position }) => position};
    bottom: ${({ align }) => (align === "right" ? "5.5rem" : "2rem")};
    ${({ align }) => (align === "right" ? "right: 2rem;" : "left: 2rem;")}
    width: 9rem;
    z-index: ${({ theme }) => theme.elevationLevels.three};
`;
